import { HOME_INTRO, introParagraphs } from '@/content/home';

/**
 * The owner's intro under the home H1 (web plan W0.6). Renders nothing while
 * `HOME_INTRO` is empty: no placeholder copy ever reaches the page.
 */
export function HomeIntro({ text = HOME_INTRO }: { text?: string }) {
  const paragraphs = introParagraphs(text);
  if (paragraphs.length === 0) return null;
  return (
    <div className="mt-2 max-w-3xl space-y-2 text-sm leading-relaxed text-ink-secondary md:text-base">
      {paragraphs.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
    </div>
  );
}

export default HomeIntro;
